import RIOSidebar from '@rio-cloud/rio-uikit/Sidebar';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useSideBarContext } from '../shared/SidebarContext.tsx';

type SidebarProps = {
    isOpen: boolean;
    children?: ReactNode;
    onClose?: () => void;
    title?: string;
    footer?: ReactNode;
};

export const Sidebar = ({ isOpen, children, onClose, title, footer }: SidebarProps) => {
    const { sidebar } = useSideBarContext();

    if (sidebar?.current) {
        return createPortal(
            <RIOSidebar
                titleClassName='padding-left-5'
                title={title}
                closed={!isOpen}
                onClose={onClose}
                position={RIOSidebar.RIGHT}
                footer={footer}
                resizable
                minWidth={350}
                width={500}
                maxWidth={800}
                switchModeBreakpoint={1100}
            >
                {children}
            </RIOSidebar>,
            sidebar.current
        );
    }
    return null;
};
